import { makeStyles } from '@material-ui/core/styles';

export const LocationListStyles =
makeStyles((theme) => ({
    locationList: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.down('sm')]: {
            maxWidth: "100%",
        },
    },

    locationListItem: {
        cursor: "pointer",
        '&:hover': {
            backgroundColor: theme.palette.primary.lightest,
        },
    },

    locationListHighlight: {
        background: theme.palette.primary.light,
    },

    locationListSelected: {
        background: theme.palette.primary.light,
    },

    locationListAvatar: {
        margin: "auto",
        marginTop: "5px",
    },

    locationListAddress: {
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },

    locationListControlButton: {
        paddingTop: 0,
        paddingBottom: 0,
        verticalAlign: "top",
    },

    locationListDistanceContainer: {
        fontSize: "1.3em",
        fontWeight: "bold"
    },

    locationListDistance: {
        display: 'inline-block',
        marginLeft: '20px',
    },
}));
